export default __webpack_public_path__ + "static/media/Kelly.b6f4ef82.jpg";